const OnEscape = function (ev) {
  if (ev.keyCode === 27) {
    this.editRole.hideModal()
  }
}

export default OnEscape
